import React from 'react'
import { NavLink, Outlet } from 'react-router-dom'
import { useI18n } from '../../i18n'
import { AGENT_KEYS } from '../../config/graphEntities'

const PIPELINE_AGENTS = AGENT_KEYS.filter((k) => k !== 'proactive_message_generator')
const PROACTIVE_AGENT = 'proactive_message_generator'

/** Layout для Agents: табы агентов (как этапы), без сайдбара. Proactive — в отдельном блоке. */
export default function SettingsAgentsLayout() {
  const { t } = useI18n()

  return (
    <div className="settings-agents-tabs-layout">
      <div className="settings-agents-tabs-row">
        <nav className="settings-agents-tabs settings-agents-tabs--pipeline">
          {PIPELINE_AGENTS.map((key) => (
            <NavLink
              key={key}
              to={key}
              className={({ isActive }) => `settings-tab ${isActive ? 'active' : ''}`}
            >
              {t(`settings.agent.label.${key}`) || key}
            </NavLink>
          ))}
        </nav>
        <nav className="settings-agents-tabs settings-agents-tabs--proactive">
          <NavLink
            to={PROACTIVE_AGENT}
            className={({ isActive }) => `settings-tab ${isActive ? 'active' : ''}`}
          >
            {t(`settings.agent.label.${PROACTIVE_AGENT}`) || PROACTIVE_AGENT}
          </NavLink>
        </nav>
      </div>
      <div className="settings-agents-content">
        <Outlet />
      </div>
    </div>
  )
}
